import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import Card from 'components/Card';
import { Input } from 'components/FormFields';
import PhoneInput from 'components/FormFields/PhoneInput';
import {
  Container,
  CardHeader,
  CardIcon,
  CardTitleGroup,
  CardTitle,
  CardSubtitle,
  FormRow,
  FieldWrapper,
  LoadingContainer,
} from './StyledComponents';

// Icon
const UserIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const PromoterTab = ({ settings = {}, onSettingsChange, loading }) => {
  // Handle field changes
  const handleChange = useCallback(
    (field) => (e) => {
      const value = e?.target?.value ?? e;
      onSettingsChange({
        ...settings,
        [field]: value,
      });
    },
    [settings, onSettingsChange]
  );

  // Handle phone change (PhoneInput returns value directly, not event)
  const handlePhoneChange = useCallback(
    (value) => {
      onSettingsChange({
        ...settings,
        promoter_phone: value,
      });
    },
    [settings, onSettingsChange]
  );

  if (loading) {
    return (
      <Card>
        <LoadingContainer>Loading promoter information...</LoadingContainer>
      </Card>
    );
  }

  return (
    <Container>
      <Card>
        <CardHeader>
          <CardIcon>
            <UserIcon />
          </CardIcon>
          <CardTitleGroup>
            <CardTitle>Promoter Information</CardTitle>
            <CardSubtitle>
              Contact information for the event promoter
            </CardSubtitle>
          </CardTitleGroup>
        </CardHeader>

        <FormRow>
          <FieldWrapper noMargin>
            <Input
              label="Promoter Name"
              value={settings.promoter_name || ''}
              onChange={handleChange('promoter_name')}
              placeholder="Enter promoter name"
            />
          </FieldWrapper>
          <FieldWrapper noMargin>
            <Input
              label="Promoter Organization"
              value={settings.promoter_organization || ''}
              onChange={handleChange('promoter_organization')}
              placeholder="Enter organization name"
            />
          </FieldWrapper>
        </FormRow>

        <FormRow>
          <FieldWrapper noMargin>
            <Input
              label="Promoter Email"
              type="email"
              value={settings.promoter_email || ''}
              onChange={handleChange('promoter_email')}
              placeholder="email@example.com"
            />
          </FieldWrapper>
          <FieldWrapper noMargin>
            <PhoneInput
              label="Promoter Phone"
              value={settings.promoter_phone || ''}
              onChange={handlePhoneChange}
            />
          </FieldWrapper>
        </FormRow>

        <FormRow columns="1fr">
          <FieldWrapper noMargin>
            <Input
              label="Promoter Website"
              type="url"
              value={settings.promoter_website || ''}
              onChange={handleChange('promoter_website')}
              placeholder="https://..."
            />
          </FieldWrapper>
        </FormRow>
      </Card>
    </Container>
  );
};

PromoterTab.propTypes = {
  settings: PropTypes.shape({
    promoter_name: PropTypes.string,
    promoter_organization: PropTypes.string,
    promoter_email: PropTypes.string,
    promoter_phone: PropTypes.string,
    promoter_website: PropTypes.string,
  }),
  onSettingsChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default PromoterTab;
